import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  background: #f3f3f3;
  padding: 30px 15px;
  @media (min-width: 1025px) {
    display: grid;
    width: 100%;
    align-items: center;
    min-height: auto;
    padding: 48px 15px;
  }
`;

const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  @media (min-width: 1024px) {
    width: 100%;
  }
`;
const CatalogSection = styled.div`
  button {
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;
    grid-template-areas:
      'title description'
      'cta description'
      'logic logic';
    button {
      margin: inherit;
    }
  }
`;
const Title = styled.div`
  grid-area: title;
  h2 {
    text-transform: uppercase;
    font-weight: 400;
    margin: 0;
    font-size: 28px;
    color: ${COLORS.BLACK};
    line-height: 42px;
    @media (max-width: 1200px) {
      font-size: calc(1.3rem + 0.6vw);
    }
  }
  h4 {
    color: ${COLORS.BLACK};
    margin: 0 0 10px;
    font-size: 20px;
    line-height: 30px;
    @media (max-width: 767.98px) {
      font-size: 16px;
      line-height: 18px;
    }
  }
`;

const Description = styled.div`
  grid-area: description;
  width: 100%;
  p {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 17px;
    color: ${COLORS.BLACK};
    margin-top: 0;
    line-height: 24px;
    @media (max-width: 767.98px) {
      font-size: 13px;
      margin-bottom: 12px;
      line-height: 15px;
    }
  }
`;

const ProductSection = styled.div`
  grid-area: logic;
  width: 100%;
  margin: 40px 0;
`;
export {
  Container,
  Wrapper,
  CatalogSection,
  Title,
  Description,
  ProductSection,
};
